import React from "react";
import classNames from "classnames";
import { useSliderState } from "./useSliderState";

const SliderComponent = ({
  appearance,
  direction,
  state,
  delta,
  transform,
  contentRef,
  currentRef,
  elementsToDisplay,
}) => {
  return (
    <div
      className={classNames("slider", {
        [`slider--${appearance}`]: appearance,
        [`slider--${direction}`]: direction,
      })}
    >
      <div
        className={classNames("slider__content", {
          "slider__content--animate": state.animate || delta.x === 0,
        })}
        style={{ transform: transform }}
        ref={contentRef}
        key={state.index}
      >
        {elementsToDisplay.map(({ element, current, previous, next }) => (
          <div
            ref={current ? currentRef : undefined}
            tabIndex={current ? "-1" : undefined}
            className={classNames("slider__slide", {
              "slider__slide--prev": previous,
              "slider__slide--current": current,
              "slider__slide--next": next,
            })}
            key={current ? "current" : previous ? "previous" : "next"}
          >
            {element}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SliderComponent;

export { useSliderState };
